module.exports = __webpack_public_path__ + "img/product5.ffdddae6.png";